import React from 'react';
import { lazyLoad } from '@react-page/editor';
const Panorama = lazyLoad(() => import('@mui/icons-material/Panorama'));
export const defaultTranslations = {
    pluginName: 'Blog List',
    pluginDescription: 'Simple Blog List'
};
export const defaultSettings = {
    Controls: () => React.createElement(React.Fragment, null, " Controls for this plugin were not provided"),
    Renderer: () => React.createElement(React.Fragment, null, "Renderer; for this plugin was not provided "),
    translations: defaultTranslations,
    icon: React.createElement(Panorama, null),
    listItems: [],
};
//# sourceMappingURL=settings.js.map